import React from 'react';
import './Education.css';

interface EducationItem {
  degree: string;
  institution: string;
  period: string;
  description: string;
  achievements?: string[];
}

const Education: React.FC = () => {
  const education: EducationItem[] = [
    {
      degree: 'Bacharelado em Ciência de Dados',
      institution: 'Universidade Estácio de Sá',
      period: '2025 - Presente',
      description: 'Cursando 1º período de Ciência de Dados com foco em análise de dados, estatística, machine learning e inteligência artificial.'
    },
    {
      degree: 'Ensino Médio Completo',
      institution: 'Centro de Ensino Médio 03 do Gama',
      period: '2017 - 2019',
      description: 'Formação básica no Ensino Médio',
      achievements: [
        'Participação em projetos de tecnologia (FEBRATEC 2019)',
        'Desenvolvimento de interesse em programação (FESTIC 2019)',
        'Honra ao mérito pelo projeto Sistema Verde (FESTIC/FEBRATEC 2019)',
        'Crendenciado a Pernambuco (Expo7 2020)'
      ]
    }
  ];

  const skills = [
    { category: 'Linguagens', items: ['Python', 'JavaScript', 'TypeScript', 'PHP', 'Java', 'SQL'] },
    { category: 'Frontend', items: ['React', 'HTML5', 'CSS3', 'Bootstrap', 'TailwindCSS', 'jQuery'] },
    { category: 'Backend', items: ['Django', 'Node.js', 'Express', 'FastAPI', 'Flask'] },
    { category: 'Database', items: ['PostgreSQL', 'MySQL', 'SQLite', 'MongoDB'] },
    { category: 'DevOps & Tools', items: ['Git', 'Docker', 'Linux', 'AWS', 'VS Code'] },
    { category: 'Integrações', items: ['Conta Azul API', 'Twitch API', 'Discord API', 'REST APIs'] },
    { category: 'Outras', items: ['Electron.js', 'Data Migration', 'BI & Analytics', 'Agile/Scrum'] }
  ];

  return (
    <div className="education-page">
      <section className="education-hero">
        <div className="container">
          <h1 className="page-title">Educação & Formação</h1>
          <p className="page-subtitle">
            Minha jornada de aprendizado e desenvolvimento profissional
          </p>
        </div>
      </section>

      {/* Formal Education */}
      <section className="formal-education-section">
        <div className="container">
          <h2 className="section-title">Formação Acadêmica</h2>
          <div className="education-list">
            {education.map((edu, index) => (
              <div key={index} className="education-item">
                <div className="education-icon">
                  <i className="fas fa-graduation-cap"></i>
                </div>
                <div className="education-content">
                  <h3 className="education-degree">{edu.degree}</h3>
                  <p className="education-institution">
                    <i className="fas fa-university"></i>
                    {edu.institution}
                  </p>
                  <p className="education-period">
                    <i className="fas fa-calendar-alt"></i>
                    {edu.period}
                  </p>
                  <p className="education-description">{edu.description}</p>
                  {edu.achievements && (
                    <div className="education-achievements">
                      <h4>Destaques:</h4>
                      <ul>
                        {edu.achievements.map((achievement, idx) => (
                          <li key={idx}>
                            <i className="fas fa-check-circle"></i>
                            {achievement}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Skills Matrix */}
      <section className="skills-matrix-section">
        <div className="container">
          <h2 className="section-title">Habilidades Técnicas</h2>
          <div className="skills-matrix">
            {skills.map((skillGroup, index) => (
              <div key={index} className="skill-group">
                <h3 className="skill-category">{skillGroup.category}</h3>
                <div className="skill-items">
                  {skillGroup.items.map((item, idx) => (
                    <span key={idx} className="skill-item">{item}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Learning Philosophy */}
      <section className="learning-philosophy">
        <div className="container">
          <div className="philosophy-content">
            <i className="fas fa-lightbulb"></i>
            <h2>Aprendizado Contínuo</h2>
            <p>
              Acredito que a educação é uma jornada contínua. Estou constantemente 
              explorando novas tecnologias, participando de comunidades de desenvolvedores 
              e contribuindo para projetos open source. Meu objetivo é sempre evoluir e 
              compartilhar conhecimento com a comunidade.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Education;
